import React from 'react';
import {
  Card,
  CardSection,
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  Layout,
  Paragraph,
  SmallHeader,
} from '@axiom/ui';

import Rocket from '../public/svg/rocket.svg';
import { EnvUtil } from '../utils/env-util';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type HelpCenterChangesPageProps = {
  name?: string;
};

export const HelpCenterChangesPage = ({
  name = 'HELP_CENTER_CHANGES_PAGE',
}: HelpCenterChangesPageProps) => {
  useDocumentTitle('AxiomLaw - Help Center Changes');
  return (
    <div data-test={name}>
      <Grid name="helpCenterChangesPage">
        <GridRow>
          <GridColumn width={2} />
          <GridColumn width={8}>
            <Card name="HELP-CENTER-PAGE">
              <CardSection>
                <Layout direction="horizontal" horizontalGutter="24px">
                  <div>
                    <Rocket width="117px" height="117px" />
                  </div>
                  <div>
                    {' '}
                    <SmallHeader>
                      New Knowledge Center – Coming Soon!
                    </SmallHeader>
                    <Gutter bottom="16px" />
                    <Paragraph>
                      The Help Center is being replaced with a simplified
                      “documents on-demand” experience to connect you with the
                      information you need to build and manage your Axiom
                      career. We appreciate your patience as we work on rolling
                      out these exciting updates. If you have any questions in
                      the meantime, please don't hesitate to reach out to us.
                    </Paragraph>
                    <Gutter bottom="16px" />
                    <Paragraph>
                      <ul>
                        <li>
                          General Inquiries:{' '}
                          <a
                            data-test="axiomAnswers"
                            href={`mailto:${EnvUtil.axiomAnswersEmail}`}
                          >
                            {EnvUtil.axiomAnswersEmail}
                          </a>
                        </li>
                        <li>
                          IT Support:{' '}
                          <a href="mailto:support@axiomlaw.com">
                            support@axiomlaw.com
                          </a>
                        </li>
                      </ul>
                    </Paragraph>
                  </div>
                </Layout>
              </CardSection>
            </Card>
          </GridColumn>
        </GridRow>
      </Grid>
    </div>
  );
};
